import Controller from '@ember/controller';
import { FeedTypes } from 'mewe/constants';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';

import { fetchFeedMyWorld, getMyWorldFeed } from 'mewe/fetchers/fetch-feed';

export default class AppMyworldController extends Controller {
  // groupId, eventId, ppId - needed for single post opening so that param is kept in URL
  // and reload opens the single post again (copy post link functionality, group/event/page posts opening)
  queryParams = ['tag', 'scope', 'previewGroupId', 'ppId', 'groupId', 'eventId', 'brave', 'removedCredentials', 'context', 'show'];

  @service settings;

  @tracked tag = null;
  @tracked scope = FeedTypes.ALL;
  @tracked filter;
  @tracked previewGroupId;
  @tracked ppId;
  @tracked groupId;
  @tracked eventId;
  @tracked brave;
  @tracked removedCredentials;
  @tracked context;

  @action
  setFeedParams({ tag, scope, filter }) {
    if (tag == this.tag && scope == this.scope && filter == this.filter) return;

    if (scope && this.scope != scope) {
      this.scope = scope;
      this.model.set('feedScope', scope);
      this.settings.save('homeFeedScope', scope, { skipSuccessMessage: true });
    }

    if (this.filter != filter) {
      this.filter = filter;
      this.model.set('feedFilter', filter);
    }

    if (this.tag != tag) {
      this.tag = tag;
      this.model.set('tag', tag);
    }

    this.feedParamsChanged();
  }

  feedParamsChanged() {
    getMyWorldFeed(this.scope).get('posts').clear();

    this.model.set('feed', getMyWorldFeed(this.scope));

    if (this.scope !== FeedTypes.HASHTAG) {
      fetchFeedMyWorld(this.scope, { hashtag: this.tag }, this.filter);
    }

    if (this.brave) {
      this.brave = null;
      this.replaceWith('app.myworld', { queryParams: { brave: null } });
    }

    if (this.removedCredentials) {
      this.removedCredentials = null;
      this.replaceWith('app.myworld', { queryParams: { removedCredentials: null } });
    }
  }
}
